import moment from "moment";
import React from "react";

function ExamModuleViewStudent(props) {
  return (
    <>
      {props?.classValue && props?.assessmentSubjectValue ? (
        <>
          {props?.routineData?.length > 0 &&
          props?.filtereduniqueDates?.length > 0 ? (
            <>
              {/* <table className='table table-bordered table-striped' border="1" style={{ borderCollapse: 'collapse', width: '100%' }}> */}
              <div className="arr-table-container routine-table">
                <table className="arr-table" border={1}>
                  <thead>
                    <tr>
                      {/* added minwidth style to evenly distribute width in table column /header */}
                      <th>
                        <div style={{ fontSize: "14px", fontWeight: 600 }}>
                          Date
                        </div>
                      </th>
                      <th>
                        <div style={{ fontSize: "14px", fontWeight: 600 }}>
                          Subjects
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {props?.filtereduniqueDates?.map((date, index) => {
                      const dateKeys = Object.keys(
                        props?.filteredTable || {},
                      ).sort();
                      const dateKey = dateKeys[index];

                      const subjects = props?.filteredTable?.[dateKey] || [];

                      return (
                        <tr key={index}>
                          <td>
                            <div style={{ fontSize: "14px", fontWeight: 600 }}>
                              {date}
                            </div>
                          </td>

                          <td>
                            {subjects.length > 0 ? (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "12px",
                                }}
                              >
                                {subjects.map((subjectData, subjectIndex) => (
                                  <div
                                    key={subjectIndex}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "3px",
                                    }}
                                  >
                                    {/* Subject */}
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {subjectData.subject}
                                    </span>

                                    {/* Theory / Practical */}
                                    {subjectData.times?.map(
                                      (time, timeIndex) => (
                                        <span
                                          key={timeIndex}
                                          style={{
                                            fontSize: "14px",
                                          }}
                                        >
                                          {time.type}-
                                          {moment(time.startTime).format(
                                            "hh:mm A",
                                          )}
                                          {time.endTime &&
                                            ` to ${moment(time.endTime).format("hh:mm A")}`}
                                        </span>
                                      ),
                                    )}
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <span style={{ fontSize: "14px" }}>-</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <>
              <p className="text-center mt-2">
                The selected assessment is either not configured for the
                specified class, or there are no students available in the
                class.
              </p>
            </>
          )}
        </>
      ) : (
        <>
          <p className="text-center mt-2">
            Select the above field to view the records.
          </p>
        </>
      )}
    </>
  );
}

export default ExamModuleViewStudent;
